import { HttpClientPort } from '../../../../core/domain/ports/HttpClientPort';
import {
  AnimaliaListItemApiResponse,
  AnimaliaListResponseApiResponse,
  AnimaliaListingMapper,
} from '../../application/mappers/AnimaliaListingMapper';
import { AnimaliaListItem } from '../../domain/entities/AnimaliaListItem';
import { AnimaliaSearchRepositoryPort } from '../../domain/ports/AnimaliaSearchRepositoryPort';

export class AnimaliaSearchApiRepositoryAdapter implements AnimaliaSearchRepositoryPort {
  constructor(private readonly httpClient: HttpClientPort) {}

  async search(query: string): Promise<ReadonlyArray<AnimaliaListItem>> {
    const normalizedQuery = query.trim();
    const searchParams = new URLSearchParams({
      query: normalizedQuery,
    });
    const response = await this.httpClient.get<AnimaliaListResponseApiResponse>(
      `/api/v1/search?${searchParams.toString()}`,
    );

    return response.items.map((item: AnimaliaListItemApiResponse) =>
      AnimaliaListingMapper.fromApiResponse(item),
    );
  }
}
